import { render, staticRenderFns } from "./CustomDistribution.vue?vue&type=template&id=3f346fd0"
import script from "./CustomDistribution.vue?vue&type=script&lang=js"
export * from "./CustomDistribution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports